/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shell_Search_Shortcut_MacInputs */

const en_us2_shell_search_shortcut_mac = /** @type {(inputs: Shell_Search_Shortcut_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘K`)
};

const pt_br2_shell_search_shortcut_mac = /** @type {(inputs: Shell_Search_Shortcut_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘K`)
};

const es_419_shell_search_shortcut_mac = /** @type {(inputs: Shell_Search_Shortcut_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘K`)
};

const pt_pt2_shell_search_shortcut_mac = /** @type {(inputs: Shell_Search_Shortcut_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘K`)
};

const fr_fr2_shell_search_shortcut_mac = /** @type {(inputs: Shell_Search_Shortcut_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘K`)
};

const de_de2_shell_search_shortcut_mac = /** @type {(inputs: Shell_Search_Shortcut_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘K`)
};

const it_it2_shell_search_shortcut_mac = /** @type {(inputs: Shell_Search_Shortcut_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘K`)
};

/**
* | output |
* | --- |
* | "⌘K" |
*
* @param {Shell_Search_Shortcut_MacInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_search_shortcut_mac = /** @type {((inputs?: Shell_Search_Shortcut_MacInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Search_Shortcut_MacInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_search_shortcut_mac(inputs)
	if (locale === "es-419") return es_419_shell_search_shortcut_mac(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_search_shortcut_mac(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_search_shortcut_mac(inputs)
	if (locale === "de-DE") return de_de2_shell_search_shortcut_mac(inputs)
	if (locale === "it-IT") return it_it2_shell_search_shortcut_mac(inputs)
	return en_us2_shell_search_shortcut_mac(inputs)
});
export { shell_search_shortcut_mac as "shell.search_shortcut_mac" }